<script lang="ts">
  import { getContext, type Snippet } from 'svelte'
  import type { ToggleGroupContext } from './ToggleGroup.svelte'
  import Tooltip from '../tooltip/Tooltip.svelte'
  import { xor } from 'es-toolkit'

  type Props = {
    children: Snippet
    value: string
    title: string
  }

  const { children, value, title }: Props = $props()

  const { selected, name, type } = getContext(
    'toggle-group',
  ) as ToggleGroupContext
</script>

<Tooltip {title}>
  <!-- svelte-ignore a11y_no_noninteractive_tabindex -->
  <label tabindex="0" aria-selected={$selected?.includes(value)}>
    {@render children()}
    <input
      name={$name}
      checked={$selected?.includes(value)}
      onchange={() => {
        if ($type === 'multiple') {
          selected.set(xor(($selected as string[]) ?? [], [value]))
        }
        else {
          selected.set(value)
        }
      }}
      type={$type == 'multiple' ? 'checkbox' : 'radio'}
      {value}
    />
  </label>
</Tooltip>

<style lang="scss">
  label {
    align-items: center;
    border-radius: 0.25rem;
    cursor: pointer;
    display: flex;
    height: 1.625rem;
    min-height: 1.625rem;
    width: 1.625rem;
    min-width: 1.625rem;
    justify-content: center;
    overflow: hidden;

    input {
      display: none;
    }

    :global(svg) {
      min-width: 1rem;
      min-height: 1rem;
      height: 1rem;
      width: 1rem;
    }

    &:has(input:checked) {
      background-color: var(--toggle-group-item-active-background);
    }

    &:focus-visible {
      outline: 1px solid var(--stroke);
      outline-offset: -1px;
    }
  }
</style>
